import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/alhussaini/tek-img_03.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={701}
              height={637}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2>Platform Features</h2>
            <p>
              We incorporated features based on client requirements and what
              would set Al Hussaini Trading Company apart from other
              marketplaces. Our emphasis was on creating an eCommerce platform
              with an omnichannel interface. The customer can find products at
              an outlet or digitally more easily.
            </p>
            <ul className="ul_style alhussaini_style">
              <li>Product Catalog</li>
              <li>Payment Gateways</li>
              <li>Store locator</li>
              <li>Purchase online or pick up from an outlet</li>
              <li>Newsletters</li>
              <li>In-app wallet with points</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
